<template>
  <div class="portfolio-project">
    <span class="title" @click="showPreview">
      {{ project.title }}
    </span>
    <img
      @click="showPreview"
      :src="`/images/portfolio/${encodeURIComponent(name)}/card.jpg`"
      :srcset="`
        /images/portfolio/${encodeURIComponent(name)}/card.jpg 1x,
        /images/portfolio/${encodeURIComponent(name)}/card@2x.jpg 2x
      `"
      :alt="project.title"
    >
    <span class="description">
      {{ project.description }}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'PortfolioProject',

    props: [
      'project',
      'name',
    ],

    methods: {
      showPreview() {
        this.$root.previewedProject = {
          name: this.name,
          project: this.project,
        };
      }
    }
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  @order: {
    img: 1;
    title: 2;
    description: 3;
  }

  .portfolio-project {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 30vh;

    @media @vertical {
      width: 30vw;
      margin-top: 5vw;
    }

    @media @mobile {
      width: 45vh;
    }

    @media @mobile-vertical {
      width: 65vw;
    }

    &+& {
      margin-left: 8vh;

      @media @vertical {
        margin-left: unset;
      }
    }

    &:nth-child(even) {
      @media @vertical {
        margin-left: 6vw;
      }

      @media @mobile-vertical {
        margin-left: unset;
      }
    }

    &:nth-child(-n+2) {
      @media @vertical {
        margin-top: 0;
      }

      @media @mobile-vertical {
        margin-top: 8vw;
      }
    }

    &:first-child {
      @media @mobile-vertical {
        margin-top: 0;
      }
    }
  }

  .title {
    .link();
    font-size: 3vh;
    margin: 1.5vh 0 1vh;
    align-self: flex-start;
    order: @order[title];

    @media @vertical {
      font-size: 3vw;
      margin: 1.5vw 0 0.25vw;
    }

    @media @mobile {
      font-size: 5vh;
    }

    @media @mobile-vertical {
      font-size: @font-sizes-mv[normal] * 1.5;
      align-self: center;
    }
  }

  img {
    width: 100%;
    border-radius: 0.8vh;
    border-bottom-left-radius: 0;
    transition-property: transform, box-shadow;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    cursor: pointer;
    order: @order[img];

    [prefers-reduced-motion] & {
      transition-property: box-shadow;
    }

    @media @vertical {
      border-radius: 0.8vw;
    }

    &:hover, .title:hover + & {
      @box-shadow-color: hsla(218, 16%, 23%, 0.75);

      transform: scale(1.05);
      box-shadow: 0 0 5vh 0.2vh @box-shadow-color;

      [prefers-reduced-motion] & {
        transform: unset;
      }

      @media @vertical {
        box-shadow: 0 0 5vw 0.2vw @box-shadow-color;
      }
    }
  }

  .description {
    color: @colors[soft];
    font-weight: @font-weights[medium];
    font-size: 2vh;
    order: @order[description];

    @media @vertical {
      font-size: 2vw;
    }

    @media @mobile {
      display: none;
    }
  }
</style>